module.exports = __webpack_public_path__ + "img/food-circle-4.56e8fa98.png";